import { render, staticRenderFns } from "./PermissionError.vue?vue&type=template&id=c1dc2f8e&scoped=true"
var script = {}
import style0 from "./PermissionError.vue?vue&type=style&index=0&id=c1dc2f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dc2f8e",
  null
  
)

export default component.exports